import React from "react";

import cn from "classnames";

import ButtonGroupIcon from "@app/component/input/ButtonGroup/ButtonGroupIcon";
import { ComponentsOfProps } from "@app/util/react";

import styles from "./ButtonGroup.module.scss";
import ButtonGroupButton, {
  ButtonGroupButtonProps,
  PrivateButtonGroupButtonProps,
} from "./ButtonGroupButton";

interface ButtonGroupProps<V extends string> {
  children: ComponentsOfProps<ButtonGroupButtonProps<V> & PrivateButtonGroupButtonProps<V>>;
  className?: string;
  disabled?: boolean;
  onChange?: (value: V) => void;
  value?: V;
}

const InternalButtonGroup = <T extends string>({
  children,
  className,
  disabled,
  onChange,
  value,
}: ButtonGroupProps<T>) => {
  return (
    <div className={cn(styles.container, className)}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          disabled: disabled && child.props.value !== value,
          key: child.props.value,
          onClick: onChange,
          selected: child.props.value === value,
          ...child.props,
        })
      )}
    </div>
  );
};

const ButtonGroup = InternalButtonGroup as unknown as (<ValueType extends string = string>(
  props: ButtonGroupProps<ValueType>
) => React.ReactElement) & {
  Icon: typeof ButtonGroupIcon;
  Item: <ValueType extends string = string>(
    props: ButtonGroupButtonProps<ValueType>
  ) => React.ReactElement;
};
ButtonGroup.Item = ButtonGroupButton;
ButtonGroup.Icon = ButtonGroupIcon;

export default ButtonGroup;
